import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { CustomizationButton, DownloadButton } from 'builder/components/PreviewPanel'
import { actions, selectors } from 'builder/modules/resumeEditor'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'

import { ButtonV2 } from 'builder/components/Button'
import { useI18n } from 'builder/hooks/useI18n'
import { EditorPanelType } from 'builder/modules/generalEditor'
import { StickyTabs } from '../../TopNavBar/StickyTabs'
import { PreviewResume } from '../../PreviewResume/PreviewResume'
import {
  StartTailoringButton,
  TailoringFromPublicJobBoardHeader,
} from '../../TailoringFromPublicJobBoard'
import { TabContentProps } from '../types'

import { TabItem, TabType } from './Tabs'
import { CustomizeMobileModal } from './CustomizeMobileModal/CustomizeMobileModal'
import { FooterActions, MobileDesignContent as MobileDesignContentWrapper } from './styles'
import { DesignContentProps } from './types'

type Props = DesignContentProps &
  TabContentProps & {
    activeTab: TabType
    tabItems: TabItem<TabType>[]
    onTabChange: (tab: TabType) => void
  }

export const MobileDesignContent = ({
  resume,
  tabItems,
  activeTab,
  resumeState,
  canScrollTop,
  isRbpStepFlowActive,
  onTabChange,
  handleShareDocument,
  handleDownloadDocument,
  showResumeDistributionModal,
}: Props) => {
  const [isCustomizeModalVisible, setIsCustomizeModalVisible] = useState(false)
  const { i18n } = useI18n()
  const dispatch = useDispatch()

  const autoTailoringFromPublicJobBoard = useTypedSelector(
    selectors.autoTailoringFromPublicJobBoard,
  )

  const selectedPrefillOption = useTypedSelector(selectors.selectedPrefillOption)

  const handleCustomizeModalOpen = () => {
    setIsCustomizeModalVisible(true)
  }

  const handlePanelTypeChange = (panelType: EditorPanelType) => {
    dispatch(actions.setEditorPanelType(panelType))
  }

  return (
    <MobileDesignContentWrapper>
      {autoTailoringFromPublicJobBoard.enabled && selectedPrefillOption ? (
        <TailoringFromPublicJobBoardHeader isNewBuilderEnabled />
      ) : (
        <StickyTabs
          resumeState={resumeState}
          canScrollTop={canScrollTop}
          isRbpStepFlowActive={isRbpStepFlowActive}
        />
      )}
      <PreviewResume resume={resume} />
      <FooterActions>
        <CustomizationButton onClick={handleCustomizeModalOpen} />
        {autoTailoringFromPublicJobBoard.enabled ? (
          selectedPrefillOption ? (
            <ButtonV2 onClick={() => handlePanelTypeChange('editor')}>
              {i18n.t('builder.prefill_resume.auto_tailoring_view.header.continue')}
            </ButtonV2>
          ) : (
            <StartTailoringButton />
          )
        ) : (
          <DownloadButton
            handleDownloadDocument={handleDownloadDocument}
            handleShareDocument={handleShareDocument}
            handleCombineDocuments={() => {}}
            showResumeDistributionModal={showResumeDistributionModal}
            shouldShowIcon={false}
          />
        )}
      </FooterActions>
      {isCustomizeModalVisible && (
        <CustomizeMobileModal
          resume={resume}
          tab={activeTab}
          tabItems={tabItems}
          onTabChange={onTabChange}
          isVisible={isCustomizeModalVisible}
          onClose={() => setIsCustomizeModalVisible(false)}
        />
      )}
    </MobileDesignContentWrapper>
  )
}
